// period-picker.component.ts

import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';
import { MPI_MONTH_MAPPER } from '../shared-config';

@Component({
  selector: 'app-period-picker',
  templateUrl: './period-picker.component.html',
  standalone: false,
  styleUrls: ['./period-picker.component.scss'],
})
export class PeriodPickerComponent {
  @Input() label: string = '';
  @Input() price: string = '';
  @Input() currentlyAvailablePeriodData = {};
  @Output() yearChange = new EventEmitter<string>();
  @Output() quarterChange = new EventEmitter<string>();
  @Output() monthChange = new EventEmitter<string>();
  @Output() weekChange = new EventEmitter<string>();
  selectedDate: { year: string; quarter: string; month: string; week: string } =
    { year: '', quarter: '', month: '', week: '' };
  monthsMapper = MPI_MONTH_MAPPER;
  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes.price &&
      changes.price.previousValue !== changes.price.currentValue
    ) {
      this.selectedDate = { year: '', quarter: '', month: '', week: '' };
    }
    if (changes.currentlyAvailablePeriodData) {
      this.currentlyAvailablePeriodData =
        changes.currentlyAvailablePeriodData.currentValue;
    }
  }

  updateQuarter() {
    this.quarterChange.emit(this.selectedDate.quarter);
  }
  updateYear() {
    this.yearChange.emit(this.selectedDate.year);
  }

  updateMonth() {
    this.monthChange.emit(this.selectedDate.month);
  }

  updateWeek() {
    this.weekChange.emit(this.selectedDate.week);
  }
}
